import { YesNoAllOptions } from '~constants/maps';

import { SearchProps } from '~components/form-fields/search';

import { selectCaseManagerUsers } from '~care-workers/selectors/users';
import { selectClientBudgetStatuses } from '~support-at-home/selectors/clientBudgetStatuses';
import { selectLookupFundingTypes } from '~support-at-home/selectors/fundingTypes';
import { selectPricePlans } from '~support-at-home/selectors/pricePlans';
import { isEncryptionEnabled } from '~libs/encryptionSettings';

export const searchFields: SearchProps = {
  client_name: {
    defaultShow: true,
    type: 'text-like',
    field: 'client.full_name',
    placeholder: 'Client Name',
    caption: 'Client',
    hidden: isEncryptionEnabled,
  },
  price_plan: {
    type: 'multi-lookup',
    field: 'price_plan_revision.plan_id',
    caption: 'Price Plan',
    selectorOptions: selectPricePlans,
  },
  funding_type: {
    type: 'multi-lookup',
    field: 'funding_type_id',
    caption: 'Funding Type',
    selectorOptions: selectLookupFundingTypes,
  },
  start_date: {
    type: 'date-range',
    field: 'start_date',
    caption: 'Start Date',
  },
  end_date: {
    type: 'date-range',
    field: 'end_date',
    caption: 'End Date',
  },
  status: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'status.id',
    caption: 'Status',
    selectorOptions: selectClientBudgetStatuses,
  },
  case_manager: {
    type: 'multi-lookup',
    field: 'case_manager',
    caption: 'Case Manager',
    selectorOptions: selectCaseManagerUsers,
    defaultShow: false,
  },
  last_modified: {
    type: 'date-range',
    field: 'updated_at',
    caption: 'Last Modified',
  },
  show_outdated: {
    defaultShow: true,
    type: 'lookup',
    field: 'show_outdated',
    caption: 'Show outdated?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
  over_allocated: {
    defaultShow: true,
    type: 'lookup',
    field: 'over_allocated',
    caption: 'Over Allocated?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
  needs_review: {
    defaultShow: true,
    type: 'lookup',
    field: 'needs_review',
    caption: 'Needs Review?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
};

export default searchFields;
